import React, { useRef, useState, useEffect } from "react";
import Highcharts, { chart } from "highcharts";
import HighchartsReact from "highcharts-react-official";

const formatData = (data) => {
  if (!data && !data.length) return;
  return data.map((x) => ({
    data: [
      Number(x.count),
      Number(x.original),
      Number(x.comment_count),
      Number(x.share_count),
      Number(x.like_count),
    ],
  }));
};
export function PieChartHC({
  graphApiResponse: { hcPieChartData = [{}] },
  chartTitle,
  onEntityClick,
  reportType,
  entityList,
  showPercentage,
  isEmbededWidget,
  identifier,
  setGraphRef,
  setGraphRefList,
  mediaType,
  data,
  twitterFeeds,
}) {
  const [chartData, setChartData] = useState({});
  const ref = useRef();

  useEffect(() => {
    setGraphRef(ref);
  }, []);

  // useEffect(() => {
  //   if (data) {
  //     twitterFeeds && redrawChart();
  //   }
  // }, [data]);

  useEffect(() => {
    // if (!twitterFeeds) {
    //   redrawChart();
    // }
    redrawChart();
  }, [hcPieChartData, showPercentage]);
  // if (!hcPieChartData) {
  //   return;
  // }
  const customLabel = () => {
    if (showPercentage) {
      if (isEmbededWidget) {
        return "<b>{point.name}-{point.percentage:.1f} %";
      }
      return "{point.percentage:.1f} %";
    } else {
      if (isEmbededWidget) {
        // if (/article/i.test(chartTitle) || /word/i.test(chartTitle))
        //   return "<b>{point.name}</b>-{point.y}";
        // else 
        return "<b>{point.name}</b>-{point.y} ";
      }
      if (/article/i.test(chartTitle) || /word/i.test(chartTitle))
        return "{point.y}";
      else return "{point.y} ";
    }
  };
  const convertToInternationalCurrencySystem = (labelValue) => {
    if (!labelValue) return "NA";
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
        ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
        : // Three Zeroes for Thousands
        Math.abs(Number(labelValue)) >= 1.0e3
          ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
          : Math.abs(Number(labelValue));
  };
  const tooltip = {
    formatter: function () {
      return (
        !showPercentage ?
          "The  <b>" +
          this.series.name +
          "</b> value for <b>" +
          this.point.name +
          "</b> is <b>" +
          convertToInternationalCurrencySystem(this.y) +
          "</b>" :
          "The <b>Percent</b> value for <b>" +
          this.point.name +
          "</b> is <b>" +
          this.point.percentage.toFixed(1) +
          "</b>"
      );
    },
  };
  const redrawChart = () => {
    // if (Object.keys(hcPieChartData[0]).length > 0) {
    const colors = [];
    hcPieChartData.length && hcPieChartData.forEach((v) => {
      colors.push(v.backgroundColor);
    });
    const options = {
      chart: {
        type: "pie",
      },
      legend: {
        enabled: true,
        margin: 0,
        maxHeight: 65,
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      tooltip,
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
        },
      },
      series: [
        {
          name: "Count",
          data: hcPieChartData, //twitterFeeds ? twitterPieData : hcPieChartData,
        },
      ],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          shadow: false,
          cursor: "pointer",
          showInLegend: !isEmbededWidget,
          margin: [0, 0, 0, 0],
          colors,
        },

        series: {
          cursor: "pointer",
          events: {
            click: (e) => handlePieClick(e),
          },
          dataLabels: {
            enabled: true, //showPercentage || (isEmbededWidget && !showPercentage),
            distance: isEmbededWidget ? 20 : 3,// -15,
            format: customLabel(),
          },
        },
      },
    };
    setChartData(options);
    if (setGraphRefList) {
      setGraphRefList(identifier + mediaType, ref, options);
    }
    // }
  };

  const handlePieClick = (e) => {
    try {
      const label = e.point.options.name;
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
        labels: label,
      };
      let entity =
        entityList &&
        entityList.filter(
          (elm) => label == elm.entity_display_name?.trim() || label == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      if (
        // /ranking/i.test(reportType) &&
        /sov/i.test(reportType) &&
        /publication/i.test(reportType)
      ) {
        routeParams.publication = label;
      }

      if (/sov/i.test(reportType) && /journalist/i.test(reportType)) {
        routeParams.sourceName = label;
      }
      if (/sov/i.test(reportType) && /city/i.test(reportType)) {
        routeParams.edition = label;
      }
      if (/sov/i.test(reportType) && /keyword/i.test(reportType)) {
        routeParams.keyword = label;
      }
      if (/^Sentiment/.test(reportType)) {
        console.log("Sentiment category");
        if (/Entity/.test(reportType)) {
          // clickedEntity = label;
        } else if (/City/.test(reportType)) {
          routeParams.edition = label;
        } else if (/Publication/.test(reportType)) {
          routeParams.publication = label;
        } else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = label;
        } else if (/Keyword/.test(reportType)) {
          routeParams.keyword = label;
        }
      }
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div id={`hc-${identifier}`}>
      <HighchartsReact highcharts={Highcharts} options={chartData} ref={ref} />
    </div>
  );
}

PieChartHC.defaultProps = {
  graphApiResponse: {},
  chartTitle: "",
  onEntityClick: () => { },
  entityList: [],
  showPercentage: false,
  selectedDataType: "",
  identifier: "",
  setGraphRef: () => { },
  setGraphRefList: () => { },
};
